// src/utils.ts
export const cnpjMask = (value: string = ''): string => {
    return value
    .replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura os dois últimos 2 números, com um - antes dos dois números
};

export const telefoneMask = (value: string = ''): string => {
    value = value.replace(/\D+/g, ''); // Remove todos os caracteres não numéricos

    return value
        .replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3') // Aplica a máscara correta para números de 10 ou 11 dígitos
        .replace(/(-\d{4})\d+?$/, '$1'); // Captura os últimos 4 números, com um - antes dos quatro números
};

export const validaCNPJ = (cnpj: string) => {
    cnpj = String(cnpj).replace(/\D/g, '');

    if (cnpj.length !== 14) {
        return false;
    }

    // Valida DVs
    let size = cnpj.length - 2;
    let numeros = cnpj.substring(0, size);
    let digitos = cnpj.substring(size);
    let soma = 0;
    let pos = size - 7;
    for (let i = size; i >= 1; i--) {
        soma += Number(numeros.charAt(size - i)) * pos--;
        if (pos < 2)
            pos = 9;
    }
    const resultado1 = soma % 11 < 2 ? 0 : 11 - soma % 11
    if (resultado1 !== Number(digitos.charAt(0))) {
        return false;
    }

    size = size + 1;
    numeros = cnpj.substring(0, size);
    soma = 0;
    pos = size - 7;
    for (let i = size; i >= 1; i--) {
        soma += Number(numeros.charAt(size - i)) * pos--;
        if (pos < 2)
            pos = 9;
    }
    const resultado2 = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado2 !== Number(digitos.charAt(1))) {
        return false;
    }

    return true;
}

export interface Option {
    label: string;
    value: string;
}

export const createOption = (label: string, value: string|number): Option => ({
    label,
    value: String(value),
});
